import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { User, UserOrganization } from 'src/app/core/auth/models';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import { OrganizationService } from 'src/app/core/auth/services/organization.service';
import { Menu } from '../../models/menu';
import { environment } from 'src/environments/environment';
import { MenuService } from '../../services/menu.service';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { DynamicEntityDataRequest } from 'src/app/models/dynamic-entity-data-request';
import { AssistantService } from 'src/app/modules/assistant/services/assistant.service';
import { MoovingAssistantIA } from 'src/app/modules/assistant/models/assistant';
import { firstValueFrom } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.scss'],
})
export class SidemenuComponent implements OnInit {

  user = inject(AuthService).$user;

  public appPages: Menu[] = [];

  organization!: UserOrganization | null;
  currentUser!: User | undefined;
  assistants: MoovingAssistantIA[] = [];

  constructor(
    private router: Router,
    private authService: AuthService,
    private menuCotroller: MenuController,
    private menusService: MenuService,
    private dictionaryService: DictionaryService,
    private assistantService: AssistantService,
    private organizationService: OrganizationService) {

  }

  ngOnInit() {

    this.authService.$user.subscribe(user => {
      this.currentUser = user;
      this.menuCotroller.enable(user ? true : false);
         this.organization = this.authService.getActiveOrganization()!;
        this.getMenu();

      // this.organizationService.selectedOrganization$.subscribe(organization => {
      //   this.organization = organization;
      //   this.getMenu();
      // });



    });

    this.organizationService.selectedOrganization$.subscribe(organization => {
      this.organization = organization;
      this.getMenu();
    });

    this.menusService.menuChanged$.subscribe(() => {
      this.getMenu();
    });

  }




  logout() {
    this.authService.logOut(this.authService.getToken())
      .subscribe({
        next: resp => {
          this.authService.removeToken();
          this.authService.$user.next(undefined);
          this.router.navigate(['auth/login']);
        }
      });
  }

  async getMenu() {
    this.appPages = [
      { title: 'Inicio', url: `/assistant/dashboard`, icon: 'home-outline', iconUrl: '' },
      {
        title: "Asistentes", url: ``, icon: 'chatbubbles-outline', iconUrl: '', children: [

        ]
      },
      {
        title: 'Acciones', url: `/actions`, icon: 'server-outline', iconUrl: '', children: []
      },
      {
        title: 'Formularios', url: ``, icon: 'document-text-outline', iconUrl: '', children: []
      },
      { title: 'Reclutamiento', url: `/recruitment`, icon: 'people-outline', iconUrl: '', children: [] },
      {
        title: 'Consultas IA', url: `/chat`, icon: 'chatbubble-ellipses-outline', iconUrl: '', children: []
      },
      {
        title: 'Documentos', url: `/documents`, icon: 'document-outline', iconUrl: '', children: []
      },
      {
        title: 'Reuniones', url: `/meetings`, icon: 'people-outline', iconUrl: '', children: []
      },
      {
        title: 'Configuración', url: ``, icon: 'settings-outline', iconUrl: '', children: [
          { title: 'Configuración de asistentes', url: `/assistant/list`, icon: '', iconUrl: '' },
        ]
      }

    ];

    this.assistants = (await this.getAssistants(this.currentUser?.id!));
    const assistantsMenu: Menu[] = [];
    this.assistants.forEach(a => {
      if (a.visibleInMenu) {
        assistantsMenu.push({ title: a.name, url: '', icon: '', iconUrl: '', actionClick: () => this.selectAgent(a) });
      }
    });
    const assistantsMenuWithCreate = [
      ...assistantsMenu
    ];

    const assistantsMenuIndex = this.appPages.findIndex(menu => menu.title === "Asistentes");
    if (assistantsMenuIndex !== -1) {
      this.appPages[assistantsMenuIndex].children = assistantsMenuWithCreate;
    }

    const dataRequest: DynamicEntityDataRequest = {
      pageNumber: 1,
      pageSize: 10,
      filters: [
        {
          field: 'organizationId',
          value: String(this.organization?.id),
        }
      ]
    }

    this.dictionaryService.getDynamicEntityRecords(dataRequest, environment.dashboardsEntityId)
      .subscribe({
        next: (resp: any) => {
          const dashboards: Menu[] = resp.records.map((dashboard: any) => {
            return { title: dashboard.code, url: `/queries/dashboard/${dashboard.idTelar}`, icon: '', iconUrl: '' };
          });

          const optionsMenu: Menu[] = this.appPages.filter((option) => option.title !== 'Tableros')!;

          this.appPages = [...optionsMenu!, { title: 'Tableros', url: ``, icon: 'pie-chart-outline', iconUrl: '', children: dashboards }];
        }
      });
  }

  async getAssistants(userId: string) {
    return await firstValueFrom(this.assistantService.getByOrganizationId(this.organization?.id!));
  }

  selectAgent(moovingAssistant: MoovingAssistantIA) {
    this.assistantService.setCurrentAssistant(moovingAssistant);
  }

}
